export default "__VITE_ASSET__bvrITq$i__"